<template>
    <div class="common-content swiper-container clear" :class="prefix">
        <div>
            <div v-for="(c, idx) in this.content"
                 class="item swiper-slide will-animate"
                 data-ani="animated fadeInUp"
                 :style="'width: ' + itemWidth"
                 :key="idx">
                <div class="icon"><img :src="icon[idx]"/></div>
                <div class="title" v-html="c.name"></div>
                <div class="desc" v-html="c.desc"></div>
            </div>
        </div>
        <!--<div class="common-content-pagination" :class="prefix"></div>-->
    </div>
</template>

<script>

  export default {
    name: "common-content",
    props: ['content', 'icon', 'prefix'],
    data() {
      return {
        itemWidth: '0'
      }
    },
    mounted() {
      this.itemWidth = (Math.floor((1 / this.content.length) * 1000000) / 10000) + "%"
    }
  }
</script>

<style scoped>
    .item {
        float: left;
        padding: 40px;
        flex: none;
        text-align: center;
        /*width: 33.3333%;*/
    }

    div.item  div.icon > img {
        width: 128px;
    }

    div.item div.title {
        font-size: 18px;
        font-weight: 600;
        padding: 20px;
        /*line-height: 32px;*/
    }

    div.item div.desc {
        font-size: 16px;
        font-weight: 300;
    }

    .common-content-pagination {
        display: none;
    }

    @media screen and (max-width: 720px) {
        .common-content-pagination {
            display: block;
            text-align: center;
            margin-top: 40px;
        }

        .item {
            width: 100% !important;
            position: relative;
            flex: none;
            padding: 0;
            float: left;
            margin-bottom: 80px;
        }

        .item:first-child {
            margin-top: 40px;
        }

        .item:last-child {
            margin-bottom: 40px;
        }

        div.item div.title {
            font-size: 20px;
            line-height: 36px;
            padding: 0;
            padding-left: 10px;
            margin-bottom: 10px;
        }

        div.item div.desc {
            clear: both;
        }

        div.item div.icon > img {
            width: 100px;
            margin-bottom: 10px;
        }
    }
</style>